// Модуль «Корректировка рейса у заказчика» — чистая логика плашки «Работа с ТМС» (без Vue и сети).
// Решение Анны Биктимеровой 04.11.2026: исправление машины в рейсе после регистрации — письмо-просьба
// заказчику открыть рейс. Плашка рассказывает по порядку: что случилось → на что влияет → что делать.

export const PARTS = ['vehicle', 'trailer', 'driver']
export const PART_LABELS = { vehicle: 'Тягач', trailer: 'Прицеп', driver: 'Водитель' }

const PART_MARKS = [
  // Только явные указания роли («прицеп: в TMS …», «mismatch: прицеп»): в общих фразах
  // («менять машину и прицеп», «водителю не отдадут документы») роль не угадываем.
  ['trailer', ['прицеп:', 'mismatch: прицеп', 'trailer']],
  ['driver', ['водитель:', 'driver']],
  ['vehicle', ['тягач', 'vehicle']],
]
const NEEDS_CUSTOMER = [
  'зарегистрировал', 'регистрац', 'valueisreadonly', 'только до ввода фактической даты',
  'сверка с tms', 'identity mismatch', 'другой госномер', 'в tms ',
]
const MISMATCH = /identity mismatch:\s*(\S+)\s+ERP=(\S*)\s+ссылается на TMS=(.+?)\s+id=/i

const low = (text) => String(text || '').toLowerCase()

export function needsCustomer(text, registered = false) {
  if (registered) return true
  const t = low(text)
  return NEEDS_CUSTOMER.some((mark) => t.includes(mark))
}

export function guessParts(text) {
  const t = low(text)
  const found = PART_MARKS.filter(([, marks]) => marks.some((m) => t.includes(m))).map(([part]) => part)
  const ordered = PARTS.filter((p) => found.includes(p))
  return ordered.length ? ordered : ['vehicle']
}

// Технический текст ошибки → понятная фраза. Пусто — нечего показывать.
export function humanizeTmsError(text) {
  const raw = String(text || '').trim()
  if (!raw) return ''
  const t = low(raw)
  if (t.includes('valueisreadonly') || t.includes('только до ввода фактической даты')) {
    return 'Водитель уже зарегистрировался на погрузке — TMS не даёт менять машину и прицеп.'
  }
  const mismatch = raw.match(MISMATCH)
  if (mismatch) {
    return 'В справочнике TMS у машины (' + mismatch[1] + ') другой госномер: в ERP ' + (mismatch[2] || '—') + ', в TMS ' + mismatch[3] + '.'
  }
  let clean = raw.replace(/^TMS:\s*/i, '')
  if (/^api_reject:\s*TmsApiError$/i.test(clean) || /^TmsApiError$/i.test(clean)) {
    return 'TMS не приняла исполнителя. Причина — в журнале обмена с TMS.'
  }
  clean = clean.replace(/^(validation|api_reject|registered|readback):\s*/i, '')
  return clean.charAt(0).toUpperCase() + clean.slice(1)
}

// Рассказ плашки: тон (для цвета), подпись статуса (всегда текстом), что случилось, на что влияет, что делать.
export function issueStory(errorText, { registered = false, requested = null } = {}) {
  const what = humanizeTmsError(errorText)
  if (!what) return null
  const customer = needsCustomer(errorText, registered)
  if (requested) {
    const sent = requested.status === 'sent'
    return {
      tone: 'wait',
      status: sent ? 'Ждём заказчика' : 'Письмо на подтверждении',
      what,
      impact: 'Пока рейс в TMS не открыт, исправить исполнителя нельзя.',
      next: sent
        ? 'Письмо ушло заказчику. Когда рейс откроют, отправьте исполнителя в TMS ещё раз.'
        : 'Письмо ждёт кнопки «Отправить» руководителя: «Претензионная работа» → «Письма на подтверждение».',
      canRequest: false,
    }
  }
  return {
    tone: customer ? 'urgent' : 'warn',
    status: customer ? 'Нужен заказчик' : 'Нужно исправить данные',
    what,
    impact: customer
      ? 'Если данные не исправить до погрузки, водителю могут не отдать документы.'
      : 'Исполнитель не попадёт в TMS, пока причина не устранена.',
    next: customer
      ? 'Попросите заказчика открыть рейс — письмо с правильными данными соберёт система.'
      : 'Исправьте данные исполнителя в ERP и отправьте исполнителя в TMS ещё раз.',
    canRequest: customer,
  }
}

export function partsQuery(parts) {
  return PARTS.filter((p) => (parts || []).includes(p)).join(',')
}

export function requestResultText(item) {
  if (!item) return ''
  if (item.status === 'sent') return 'Письмо отправлено заказчику.'
  if (item.status === 'failed') return 'Письмо не ушло — руководитель увидит ошибку и отправит повторно.'
  const again = item.created === false ? 'Такая просьба уже собрана. ' : ''
  return again + 'Письмо ждёт «Отправить» руководителя в «Претензионная работа» → «Письма на подтверждение».'
}
